import styled from "styled-components"

import AdUnit from "components/page-components/ad-unit"

export const AboveNavigationAd = styled(AdUnit)`
  height: 5rem;
  margin: 0;
  background-color: #fff;
`
